import script from "./TeacherDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherDetail.vue?vue&type=script&setup=true&lang=js"

import "./TeacherDetail.vue?vue&type=style&index=0&id=463382e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463382e6"]])

export default __exports__